import { get, post } from "services/httpService";

const SERVICE_URLS = {
  sendContactOrFeatureDetails: () => "contact-us-request-feature/",
  sendBugDetails: () => "report_bug/",
  getFaqs: () => "dynamic-json-schema?type=FAQ_DATA",
};

export const sendContactOrFeatureDetails = (payload) =>
  post(SERVICE_URLS.sendContactOrFeatureDetails(), payload);

export const sendBugDetails = (payload) =>
  post(SERVICE_URLS.sendBugDetails(), payload);

export const getFaqs = (payload) => get(SERVICE_URLS.getFaqs(), payload);
